<template>
    <b-dropdown-item
        :to="to"
        :variant="color"
        @click="$emit('click', $event)"
    >
        <slot />
    </b-dropdown-item>
</template>

<script>
import {BDropdownItem} from 'bootstrap-vue'

export default {
    components: {BDropdownItem},
    props: {
        to: {type: [Object, String]},
        color: {type: String},
    },
}
</script>